import type { AppConfig } from '@/types';

export async function loadConfig(): Promise<AppConfig> {
  const response = await fetch('/config.json');

  if (!response.ok) {
    throw new Error(`Failed to load configuration: ${response.statusText}`);
  }

  return response.json();
}
